<template>
  <v-dialog v-model="asking" persistent width="400px">
    <v-card>
      <v-card-title class="warning--text">
        <v-icon class="mr-2" color="warning">notifications_active</v-icon>
        {{ $t('Inactivity.title') }}
      </v-card-title>
      <v-card-text>
        {{ $t('Inactivity.text') }}
      </v-card-text>
      <v-card-actions>
        <v-btn block @click="reply" color="primary">
          <v-icon left>campaign</v-icon>
          {{ $t('Inactivity.btn') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { time } from '@/config/timeout'

export default {
  name: 'IdleTimeout',
  data: () => ({
    timer: null,
    events: ['mousemove', 'mousedown', 'touchstart', 'click', 'keypress'],
    asking: false,
    askTimer: null,
  }),
  methods: {
    ...mapActions('auth', [
      'disconnectUser'
    ]),
    start () {
      for (const event of this.events) {
        window.addEventListener(event, this.reset)
      }
      this.timer = setTimeout(this.ask, time)
    },
    stop () {
      for (const event of this.events) {
        window.removeEventListener(event, this.reset)
      }
      if (this.timer) clearTimeout(this.timer)
    },
    reset () {
      this.stop()
      this.start()
    },
    ask () {
      this.stop()
      this.asking = true
      this.askTimer = setTimeout(this.disconnectUser, 10000)
    },
    reply () {
      this.asking = false
      if (this.askTimer) clearTimeout(this.askTimer)
      this.start()
    }
  },
  created () {
    this.start()
  },
  beforeDestroy () {
    this.stop()
  }
}
</script>